export enum TradeReportTransType {
  /** New */
  New = 0,
  /** Cancel */
  Cancel = 1,
  /** Replace */
  Replace = 2,
  /** Release */
  Release = 3,
  /** Reverse */
  Reverse = 4,
  /** Cancel Due To Back Out of Trade */
  CancelDueToBackOutOfTrade = 5,
}
